function OrderStatusForm() {
    this.orderNumber = '';
    this.email = '';
}

export default OrderStatusForm;